/* Vogue Bazaar theme — global.js */
(function () {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- helpers ---------- */
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = T.moneyFormat || '₹{{amount}}';
    const amount = cents / 100;
    const withDecimals = fmt.indexOf('no_decimals') === -1;
    const num = withDecimals ? amount.toFixed(2) : Math.round(amount).toString();
    const parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  window.theme.formatMoney = formatMoney;

  let toastTimer;
  function toast(msg, linkText, href) {
    const el = $('#toast');
    if (!el) return;
    el.innerHTML = '';
    el.append(document.createTextNode(msg));
    if (linkText && href) {
      const a = document.createElement('a'); a.href = href; a.textContent = linkText; el.append(a);
    }
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.classList.remove('is-visible'); setTimeout(() => (el.hidden = true), 250); }, 3500);
  }
  window.theme.toast = toast;

  /* ---------- cart ---------- */
  async function cartAdd(id, qty, source) {
    const res = await fetch(T.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: qty || 1 }] })
    });
    if (!res.ok) { const e = await res.json().catch(() => ({})); throw new Error(e.description || e.message || 'Could not add'); }
    const data = await res.json();
    await refreshCartCount();
    document.dispatchEvent(new CustomEvent('theme:cart:added', { detail: { source: source || null, item: data } }));
    return data;
  }
  const drawerMode = () => !!(T.motion && T.motion.cartType === 'drawer' && document.getElementById('CartDrawer'));
  async function cartChange(line, quantity) {
    const res = await fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    return res.json();
  }
  async function refreshCartCount() {
    try {
      const c = await (await fetch(T.routes.cart + '.js')).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
    } catch (e) { /* noop */ }
  }
  window.theme.cartAdd = cartAdd; window.theme.cartChange = cartChange;

  /* ---------- wishlist (localStorage) ---------- */
  const WL_KEY = 'vb_wishlist';
  const wl = {
    get() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } },
    set(v) { try { localStorage.setItem(WL_KEY, JSON.stringify(v)); } catch (e) { } this.render(); },
    has(h) { return this.get().includes(h); },
    toggle(h) { const l = this.get(); const i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.push(h); this.set(l); return i === -1; },
    add(h) { if (!this.has(h)) { const l = this.get(); l.push(h); this.set(l); } },
    remove(h) { this.set(this.get().filter(x => x !== h)); },
    render() {
      const l = this.get();
      $$('[data-wishlist-count]').forEach(el => { el.textContent = l.length; el.dataset.count = l.length; });
      $$('[data-wishlist-toggle]').forEach(btn => {
        const on = l.includes(btn.dataset.wishlistToggle);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        const label = btn.querySelector('[data-wishlist-label]');
        if (label) label.textContent = on ? T.strings.wishlisted : T.strings.wishlist;
      });
    }
  };
  window.theme.wishlist = wl;
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const added = wl.toggle(btn.dataset.wishlistToggle);
    toast(added ? T.strings.wishlisted : 'Removed from wishlist');
  });

  /* ---------- header: mobile drawer ---------- */
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-drawer-open]');
    if (open) { const d = $(open.dataset.drawerOpen); if (d) { d.setAttribute('open', ''); document.body.style.overflow = 'hidden'; } }
    const close = e.target.closest('[data-drawer-close]');
    if (close) { const d = close.closest('.drawer'); if (d) { d.removeAttribute('open'); document.body.style.overflow = ''; } }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { $$('.drawer[open],.modal[open]').forEach(d => d.removeAttribute('open')); document.body.style.overflow = ''; }
  });

  /* ---------- predictive search ---------- */
  $$('[data-predictive]').forEach(form => {
    const input = $('input[name="q"]', form);
    const box = $('.predictive', form);
    if (!input || !box) return;
    let timer, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(async () => {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search`;
          const html = await (await fetch(url, { signal: ctrl.signal })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('#shopify-section-predictive-search');
          box.innerHTML = inner ? inner.innerHTML : '';
          box.hidden = !box.innerHTML.trim();
        } catch (e) { /* aborted */ }
      }, 250);
    });
    document.addEventListener('click', e => { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('focus', () => { if (box.innerHTML.trim() && input.value.trim().length > 1) box.hidden = false; });
  });

  /* ---------- hero slider ---------- */
  $$('[data-hero]').forEach(hero => {
    const track = $('.hero__track', hero);
    const slides = $$('.hero__slide', hero);
    const dots = $$('.hero__dot', hero);
    if (slides.length < 2) return;
    let i = 0, timer;
    const autoplay = parseInt(hero.dataset.autoplay || '0', 10);
    const go = n => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    const start = () => { if (autoplay) { clearInterval(timer); timer = setInterval(() => go(i + 1), autoplay * 1000); } };
    const prev = $('.hero__arrow--prev', hero), next = $('.hero__arrow--next', hero);
    if (prev) prev.addEventListener('click', () => { go(i - 1); start(); });
    if (next) next.addEventListener('click', () => { go(i + 1); start(); });
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); start(); }));
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', start);
    let sx = 0;
    hero.addEventListener('touchstart', e => (sx = e.touches[0].clientX), { passive: true });
    hero.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1); });
    start();
  });

  /* ---------- product carousels ---------- */
  $$('[data-carousel]').forEach(c => {
    const track = $('.carousel__track', c);
    if (!track) return;
    const step = () => track.clientWidth * 0.8;
    const prev = $('.carousel__arrow--prev', c), next = $('.carousel__arrow--next', c);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  /* ---------- collection facets ---------- */
  const facetsForm = $('#FacetsForm');
  if (facetsForm) {
    let t;
    const submit = () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const params = new URLSearchParams(new FormData(facetsForm));
        for (const k of Array.from(params.keys())) if (params.get(k) === '') params.delete(k);
        const qs = params.toString();
        const url = qs ? `${location.pathname}?${qs}` : location.pathname;
        history.replaceState({}, '', url);
        const target = $('#CollectionResults');
        if (!target) return;
        target.classList.add('is-loading');
        const sectionId = target.dataset.section;
        const html = await (await fetch(`${url}${qs ? '&' : '?'}section_id=${sectionId}`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('#CollectionResults');
        if (fresh) target.innerHTML = fresh.innerHTML;
        const freshCount = doc.querySelector('[data-results-count]');
        $$('[data-results-count]').forEach(el => { if (freshCount) el.textContent = freshCount.textContent; });
        const freshChips = doc.querySelector('#ActiveChips');
        const chips = $('#ActiveChips');
        if (freshChips && chips) chips.innerHTML = freshChips.innerHTML;
        $$('.facet', doc).forEach(ff => {
          const cur = $(`.facet[data-facet="${ff.dataset.facet}"]`);
          if (cur && cur.dataset.facet !== 'price') { const wasOpen = cur.hasAttribute('open'); cur.innerHTML = ff.innerHTML; if (wasOpen) cur.setAttribute('open', ''); }
        });
        target.classList.remove('is-loading');
        wl.render();
        bindRange();
      }, 200);
    };
    facetsForm.addEventListener('change', e => { if (e.target.type !== 'range' && e.target.type !== 'number') submit(); });
    facetsForm.addEventListener('submit', e => { e.preventDefault(); submit(); });
    $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => {
      let h = $('input[name="sort_by"]', facetsForm);
      if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'sort_by'; facetsForm.append(h); }
      h.value = sel.value; const lbl = $('[data-sort-label]'); if (lbl) lbl.textContent = sel.options[sel.selectedIndex].text; submit();
    }));
    document.addEventListener('click', e => {
      const more = e.target.closest('[data-facet-more]');
      if (more) { const list = more.previousElementSibling; list.classList.toggle('facet__list--collapsed'); more.textContent = list.classList.contains('facet__list--collapsed') ? more.dataset.facetMore : '− less'; }
      const clear = e.target.closest('[data-facet-clear]');
      if (clear) { e.preventDefault(); $$('input[type=checkbox]', facetsForm).forEach(c => (c.checked = false)); $$('input[data-price-min],input[data-price-max]', facetsForm).forEach(c => (c.value = '')); const lo = $('input[data-lo]'), hi = $('input[data-hi]'); if (lo) lo.value = 0; if (hi) hi.value = hi.max; submit(); }
      const rm = e.target.closest('[data-remove-filter]');
      if (rm) { e.preventDefault(); const { name, value } = rm.dataset; $$(`input[name="${name}"]`, facetsForm).forEach(c => { if (c.type === 'checkbox' && c.value === value) c.checked = false; if (c.type !== 'checkbox') c.value = ''; }); submit(); }
      const toggle = e.target.closest('[data-facets-toggle]');
      if (toggle) { const f = $('.facets'); if (f) { f.classList.toggle('is-open'); document.body.style.overflow = f.classList.contains('is-open') ? 'hidden' : ''; } }
      const close = e.target.closest('[data-facets-close]');
      if (close) { const f = $('.facets'); if (f) f.classList.remove('is-open'); document.body.style.overflow = ''; }
    });
    function bindRange() {
      const wrap = $('[data-price-range]');
      if (!wrap || wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      const lo = $('input[data-lo]', wrap), hi = $('input[data-hi]', wrap);
      const nlo = $('input[data-price-min]', facetsForm), nhi = $('input[data-price-max]', facetsForm);
      const fill = $('.facet__range-fill', wrap), label = $('.facet__range-label', wrap);
      if (!lo || !hi || !nlo || !nhi) return;
      const max = parseFloat(lo.max);
      const paint = () => {
        let a = parseFloat(lo.value), b = parseFloat(hi.value);
        if (a > b) { const tmp = a; a = b; b = tmp; }
        fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%';
        label.textContent = `${T.pricePrefix || ''}${Math.round(a).toLocaleString()} – ${T.pricePrefix || ''}${Math.round(b).toLocaleString()}${b >= max ? '+' : ''}`;
        nlo.value = a > 0 ? a : ''; nhi.value = b < max ? b : '';
      };
      [lo, hi].forEach(r => { r.addEventListener('input', paint); r.addEventListener('change', submit); });
      paint();
    }
    bindRange();
  }

  /* ---------- product page ---------- */
  const pf = $('[data-product-form]');
  if (pf) {
    const variantsEl = $('[data-variants]');
    const variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]');
    const idInput = $('input[name="id"]', pf);
    const addBtn = $('[data-add-to-bag]', pf);
    const addLabel = $('[data-add-label]', addBtn);
    const priceEl = $('[data-product-price]');
    const optionGroups = $$('[data-option-index]');
    const selected = optionGroups.map(g => { const c = $('[aria-checked="true"]', g); return c ? c.dataset.value : null; });
    const hasSizeOption = optionGroups.some(g => g.dataset.optionIsSize === 'true');

    function currentVariant() {
      if (selected.some(v => v === null)) return null;
      return variants.find(v => v.options.every((o, i) => o === selected[i]));
    }
    function paintAvailability() {
      optionGroups.forEach((g, gi) => {
        $$('.swatch-btn', g).forEach(btn => {
          const test = selected.slice(); test[gi] = btn.dataset.value;
          const any = variants.some(v => v.options.every((o, i) => test[i] === null || o === test[i]) && v.available);
          btn.classList.toggle('is-disabled', !any);
        });
      });
    }
    function update() {
      const v = currentVariant();
      if (v) {
        idInput.value = v.id;
        if (priceEl) {
          const price = formatMoney(v.price);
          let html = `<span class="price">${price}</span>`;
          if (v.compare_at_price && v.compare_at_price > v.price) {
            const pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
            html += ` <span class="mrp">MRP <s>${formatMoney(v.compare_at_price)}</s></span> <span class="discount">(${pct}% OFF)</span>`;
          }
          priceEl.innerHTML = html;
        }
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
      paintAvailability();
    }
    optionGroups.forEach((g, gi) => g.addEventListener('click', e => {
      const btn = e.target.closest('.swatch-btn'); if (!btn) return;
      $$('.swatch-btn', g).forEach(b => b.setAttribute('aria-checked', 'false'));
      btn.setAttribute('aria-checked', 'true'); selected[gi] = btn.dataset.value; update();
    }));
    update();

    pf.addEventListener('submit', async e => {
      e.preventDefault();
      if (!currentVariant()) {
        toast(hasSizeOption ? T.strings.selectSize : 'Please select all options');
        const g = optionGroups.find(x => x.dataset.optionIsSize === 'true') || optionGroups[0];
        if (g) { g.scrollIntoView({ behavior: 'smooth', block: 'center' }); g.classList.add('shake'); setTimeout(() => g.classList.remove('shake'), 500); }
        return;
      }
      const old = addLabel.textContent;
      addBtn.disabled = true; addLabel.innerHTML = '<span class="spinner"></span>';
      try {
        const src = document.querySelector('.product__gallery img, .product__gallery--mobile img');
        await cartAdd(parseInt(idInput.value, 10), 1, src);
        if (!drawerMode()) toast(T.strings.added, T.strings.goToBag, T.routes.cart);
      } catch (err) { toast(err.message); }
      addLabel.textContent = old;
      addBtn.disabled = false;
    });

    // pincode check (client-side estimate; swap for a real serviceability API when you have one)
    const pin = $('[data-pincode]');
    if (pin) {
      const input = $('input', pin), msg = $('[data-pincode-msg]');
      const check = () => {
        const v = input.value.trim();
        if (!/^\d{6}$/.test(v)) { msg.className = 'pincode__msg bad'; msg.textContent = T.strings.pincodeBad; return; }
        const d = new Date(); d.setDate(d.getDate() + 3 + (parseInt(v[0], 10) % 3));
        const date = d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
        msg.className = 'pincode__msg ok'; msg.innerHTML = `${T.strings.pincodeOk.replace('[date]', date)}<br><span class="text-success">${T.strings.pincodeCod}</span>`;
        try { localStorage.setItem('vb_pincode', v); } catch (e) { }
      };
      $('button', pin).addEventListener('click', check);
      input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      try { const saved = localStorage.getItem('vb_pincode'); if (saved) { input.value = saved; check(); } } catch (e) { }
    }

    // collapsible blocks
    $$('[data-collapsible]').forEach(c => {
      const btn = c.nextElementSibling;
      if (!btn || !btn.matches('.collapsible-toggle')) return;
      if (c.scrollHeight <= c.clientHeight + 4) { btn.hidden = true; return; }
      btn.addEventListener('click', () => { c.classList.toggle('is-open'); btn.textContent = c.classList.contains('is-open') ? btn.dataset.less : btn.dataset.more; });
    });

    // modals
    document.addEventListener('click', e => {
      const o = e.target.closest('[data-modal-open]'); if (o) { e.preventDefault(); const m = $(o.dataset.modalOpen); if (m) m.setAttribute('open', ''); }
      const c = e.target.closest('[data-modal-close]'); if (c) { const m = c.closest('.modal'); if (m) m.removeAttribute('open'); }
    });

    // share
    const share = $('[data-share]');
    if (share) share.addEventListener('click', async () => {
      const data = { title: document.title, url: location.href };
      if (navigator.share) { try { await navigator.share(data); } catch (e) { } }
      else if (navigator.clipboard) { await navigator.clipboard.writeText(location.href); toast('Link copied'); }
    });

    // mobile gallery dots
    const mg = $('.product__gallery--mobile .track');
    if (mg) {
      const dots = $$('.product__gallery--mobile .dots span');
      mg.addEventListener('scroll', () => { const i = Math.round(mg.scrollLeft / mg.clientWidth); dots.forEach((d, k) => k === i ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current')); }, { passive: true });
    }
  }

  /* ---------- cart page ---------- */
  const cartPage = $('[data-cart-page]');
  if (cartPage) {
    const reload = async () => {
      const html = await (await fetch(`${location.pathname}?section_id=${cartPage.dataset.section}`)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-page]');
      if (fresh) cartPage.innerHTML = fresh.innerHTML;
      refreshCartCount();
    };
    cartPage.addEventListener('change', async e => {
      const sel = e.target.closest('[data-line-qty]');
      if (sel) { cartPage.style.opacity = '.6'; await cartChange(parseInt(sel.dataset.lineQty, 10), parseInt(sel.value, 10)); await reload(); cartPage.style.opacity = ''; }
    });
    cartPage.addEventListener('click', async e => {
      const rm = e.target.closest('[data-line-remove]');
      if (rm) { cartPage.style.opacity = '.6'; await cartChange(parseInt(rm.dataset.lineRemove, 10), 0); await reload(); cartPage.style.opacity = ''; }
      const mv = e.target.closest('[data-move-wishlist]');
      if (mv) { wl.add(mv.dataset.moveWishlist); cartPage.style.opacity = '.6'; await cartChange(parseInt(mv.dataset.line, 10), 0); await reload(); cartPage.style.opacity = ''; toast('Moved to wishlist'); }
    });
    let noteT;
    cartPage.addEventListener('input', e => {
      if (!e.target.matches('[data-cart-note]')) return;
      clearTimeout(noteT);
      noteT = setTimeout(() => fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }), 500);
    });
  }

  /* ---------- wishlist page ---------- */
  const wlPage = $('[data-wishlist-page]');
  if (wlPage) {
    const grid = $('[data-wishlist-grid]', wlPage), empty = $('[data-wishlist-empty]', wlPage), count = $('[data-wishlist-page-count]');
    const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const render = async () => {
      const handles = wl.get();
      if (count) count.textContent = `${handles.length} items`;
      grid.innerHTML = ''; empty.hidden = handles.length > 0;
      const products = await Promise.all(handles.map(h => fetch(`${T.routes.root}products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)));
      products.forEach((p, i) => {
        if (!p) { wl.remove(handles[i]); return; }
        const v = p.variants.find(x => x.available) || p.variants[0];
        const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') : '';
        const pct = v.compare_at_price && v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) : 0;
        const card = document.createElement('div');
        card.className = 'card';
        card.innerHTML = `
          <a href="${T.routes.root}products/${esc(p.handle)}" class="card__media">${img ? `<img src="${esc(img)}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
          <button class="card__wish" aria-pressed="true" data-wl-remove="${esc(p.handle)}" aria-label="Remove"><svg viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2"/></svg></button>
          <div class="card__info">
            <div class="card__vendor">${esc(p.vendor)}</div>
            <div class="card__title">${esc(p.title)}</div>
            <div class="card__price"><span class="price">${formatMoney(v.price)}</span>${pct ? `<span class="compare">${formatMoney(v.compare_at_price)}</span><span class="discount">(${pct}% OFF)</span>` : ''}</div>
            <button class="btn btn--outline btn--block btn--sm" style="margin-top:10px" data-wl-bag="${v.id}" data-handle="${esc(p.handle)}" ${v.available ? '' : 'disabled'}>${v.available ? 'Move to bag' : 'Sold out'}</button>
          </div>`;
        grid.append(card);
      });
    };
    wlPage.addEventListener('click', async e => {
      const rm = e.target.closest('[data-wl-remove]'); if (rm) { wl.remove(rm.dataset.wlRemove); render(); }
      const bag = e.target.closest('[data-wl-bag]');
      if (bag) { bag.disabled = true; try { await cartAdd(parseInt(bag.dataset.wlBag, 10), 1, bag.closest('.card') && bag.closest('.card').querySelector('img')); wl.remove(bag.dataset.handle); if (!drawerMode()) toast(T.strings.added, T.strings.goToBag, T.routes.cart); render(); } catch (err) { toast(err.message); bag.disabled = false; } }
    });
    render();
  }

  /* ---------- quick add from cards ---------- */
  document.addEventListener('click', async e => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    const card = q.closest('.card'); const src = card ? card.querySelector('[data-card-img], .card__media img') : null;
    q.disabled = true;
    try { await cartAdd(parseInt(q.dataset.quickAdd, 10), 1, src); if (!drawerMode()) toast(T.strings.added, T.strings.goToBag, T.routes.cart); } catch (err) { toast(err.message); }
    q.disabled = false;
  });

  wl.render();
  refreshCartCount();
})();
